import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-popover-background',
  templateUrl: './popover-background.component.html',
  styleUrls: ['./popover-background.component.scss'],
})
export class PopoverBackgroundComponent implements OnInit {

  @Input() imageName;
  @Input() backgroundClass = "blue-background";
  @Input() addStars: boolean = false;
  @Input() allowTopDottedLines = false;
  @Input() allowSideDottedLines = true;

  imagesPath = "/assets/images/overlay-images/";
  constructor() { }

  ngOnInit() {
  }

}
